module.exports = __webpack_public_path__ + "static/PFB__0005_Grants-7264ba2c83e1702d9bb87dd5e5922c5b.png";